import { whatsApp } from "../../assets/images";

const WhatsApp = () => {
  return (
    <div
      style={{
        display: "flex",
        position: "fixed",
        bottom: 10,
        right: 10,
        cursor: "pointer",
        zIndex: 1000,
      }}
      onClick={() => {
        window.location.href = "https://wa.me/5587981717049";
      }}
    >
      <img src={whatsApp} alt="WhatsApp" width="45" height={"70"} />
    </div>
  );
};

export default WhatsApp;
